export default __webpack_public_path__ + "static/media/logo-light.74df6a24.gif";